import React, { useState } from 'react';
import { GiphyFetch } from '@giphy/js-fetch-api';
import { Grid } from '@giphy/react-components';
import { Search, X, Loader2, Image } from 'lucide-react';

const gf = new GiphyFetch(process.env.REACT_APP_GIPHY_API_KEY);

export default function GifPicker({ onGifSelect, onClose }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchKey, setSearchKey] = useState(0);

  const fetchGifs = (offset) => {
    if (searchTerm.trim()) {
      return gf.search(searchTerm, { offset, limit: 10 });
    }
    return gf.trending({ offset, limit: 10 });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchKey(prev => prev + 1);
  };

  const handleGifClick = (gif, e) => {
    e.preventDefault();
    onGifSelect({
      url: gif.images.fixed_height.url,
      width: gif.images.fixed_height.width,
      height: gif.images.fixed_height.height,
      title: gif.title
    });
    onClose();
  };

  return (
    <div className="bg-white rounded-lg shadow-xl border border-stone-200 w-[340px] max-h-[450px] flex flex-col overflow-hidden">
      {/* Header */}
      <div className="p-3 border-b border-stone-200 flex items-center justify-between bg-stone-50">
        <div className="flex items-center gap-2">
          <Image className="w-5 h-5 text-purple-500" />
          <span className="font-medium text-stone-900">GIFs</span>
        </div>
        <button
          onClick={onClose}
          className="p-1 hover:bg-stone-200 rounded-full transition-colors"
        >
          <X className="w-4 h-4 text-stone-500" />
        </button>
      </div>

      {/* Search */}
      <form onSubmit={handleSearch} className="p-2 border-b border-stone-200">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search GIFs..."
            className="w-full pl-9 pr-4 py-2 text-sm border border-stone-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500/50"
          />
        </div>
      </form>

      {/* GIF Grid */}
      <div className="flex-1 overflow-y-auto p-2" style={{ minHeight: '300px' }}>
        <Grid
          key={searchKey}
          width={316}
          columns={2}
          fetchGifs={fetchGifs}
          onGifClick={handleGifClick}
          noLink={true}
          hideAttribution={false}
        />
      </div>

      {/* Powered by GIPHY */}
      <div className="p-2 border-t border-stone-200 bg-stone-50">
        <img 
          src="https://giphy.com/static/img/poweredby_giphy.png" 
          alt="Powered by GIPHY" 
          className="h-4 mx-auto opacity-60"
        />
      </div>
    </div>
  );
}
